<template>
  <div class="rightModal">
    <b-form-group :label="$t('detail.vm.selectAttachIPv4')">
      <multiselect
        id="multiselectbox"
        v-model="form.ip"
        :options="ipList"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('detail.vm.enterIpForSearch')"
        :loading="loading"
        :custom-label="customListLabel"
        @search-change="getIPList"
        :limit="3"
        :show-no-results="false"
        :state="validateState('ip')"
      />
    </b-form-group>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'AttachIPv4',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    selectedId: String,
  },
  data() {
    return {
      form: {
        ip: '',
      },
      ipList: [],
    }
  },
  validations: {
    form: {
      ip: {
        required,
      },
    },
  },
  created() {
    this.getIPList('')
  },
  methods: {
    getIPList(search) {
      this.loading = true

      if (search != '') {
        this.ipList = []
      }

      this.getList(search)
        .then((res) => {
          this.setList(res)
          this.loading = false
        })
        .catch(() => {
          this.ipList = []
        })
    },
    getList(search) {
      return new Promise((resolve, reject) => {
        let query = `packetbender/ip?position=id|desc`

        if (search && search != '') {
          query += `&ip_addr=${search}`
        }

        if (this.selectedId && this.selectedId != '') {
          query += `&virtual_network_card_id=${this.selectedId}`
        }

        ApiService.get(query)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    setList(res) {
      this.ipList = res.data
    },
    customListLabel({ ip_addr }) {
      return `${ip_addr}`
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        ip_addr: this.form.ip.ip_addr,
      }
      ApiService.put(
        `iaas/virtual-network-cards/${this.selectedId}/ipv4-allow`,
        params
      )
        .then(({ data }) => {
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          // this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
